import { useSettings } from "@/context/SettingsContext";
import { cn } from "@/lib/utils";

export const BrandMark = ({ className, inverted = false }) => {
  const { settings, logoUrl } = useSettings();
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${settings.hub_name} logo`}
        className={cn("h-9 w-9 rounded-xl object-contain bg-white", className)}
        data-testid="brand-logo"
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn(
        "h-9 w-9 shrink-0 rounded-xl grid place-items-center text-xs font-semibold tracking-wide",
        inverted ? "bg-white/10 text-white ring-1 ring-white/20" : "bg-brand text-white",
        className
      )}
      data-testid="brand-mark"
    >
      FCG
    </span>
  );
};
